"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { detectPlatform, trackAppDownloadClick, APP_STORE_URLS } from "@/lib/utils";
import { useModal } from "@/contexts/ModalContext";

/** Platform-aware Get Started CTA for the home bottom banner. */
export function CTAGetStartedButton() {
  const { openModal } = useModal();
  const [platform, setPlatform] = useState<"android" | "ios" | "web">("web");

  useEffect(() => {
    setPlatform(detectPlatform());
  }, []);

  const handleGetStarted = () => {
    if (platform === "android") {
      trackAppDownloadClick("android");
      window.open(APP_STORE_URLS.android, "_blank");
    } else if (platform === "ios") {
      trackAppDownloadClick("ios");
      window.open(APP_STORE_URLS.ios, "_blank");
    } else {
      openModal();
    }
  };

  return (
    <Button
      size="lg"
      onClick={handleGetStarted}
      className="bg-white text-primary-700 hover:bg-primary-50 shadow-xl hover:shadow-2xl transition-all duration-300 group px-8 py-6 text-lg"
    >
      Get Started Free
      <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
    </Button>
  );
}
